import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["showButton", "hideButton", "mobileOptionalInfo", "contractaddressInfo", "marketCapFdv", "marketCapFdvToggle"];

  show() {
    this.mobileOptionalInfoTarget.classList.remove("tw-hidden")
    this.showButtonTarget.classList.add("tw-hidden")
    this.hideButtonTarget.classList.remove("tw-hidden")
    this.contractaddressInfoTarget.classList.add("tw-hidden")
  }

  hide() {
    this.mobileOptionalInfoTarget.classList.add("tw-hidden")
    this.hideButtonTarget.classList.add("tw-hidden")
    this.showButtonTarget.classList.remove("tw-hidden")
    this.contractaddressInfoTarget.classList.remove("tw-hidden")
  }

  toggleMarketCapFdvRatio() {
    if(this.marketCapFdvTarget.classList.contains("tw-hidden")) {
      this._showMarketCapFdvRatio()
    } else {
      this._hideMarketCapFdvRatio()
    }
  }

  _showMarketCapFdvRatio() {
    this.marketCapFdvTarget.classList.remove("tw-hidden")
    this.marketCapFdvToggleTarget.classList.remove("fa-chevron-down")
    this.marketCapFdvToggleTarget.classList.add("fa-chevron-up")
  }

  _hideMarketCapFdvRatio() {
    this.marketCapFdvTarget.classList.add("tw-hidden")
    this.marketCapFdvToggleTarget.classList.add("fa-chevron-down")
    this.marketCapFdvToggleTarget.classList.remove("fa-chevron-up")
  }
}
